import { Injectable } from '@angular/core';
import { Actions, Store } from '@ngxs/store';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class AuthControlFacade {
  constructor(protected store: Store,
              protected actions$: Actions) {
  }

  //<editor-fold desc="Selectors">

  isAuthenticated$ = this.store.select(FlatStates.AuthControlState.isAuthenticated$);
  canAccessAuthor$ = this.store.select(FlatStates.AuthControlState.canAccessAuthor$);
  user$ = this.store.select(FlatStates.AuthControlState.currentUser$);

  //</editor-fold>

  //<editor-fold desc="Snapshot Selectors">

  snapshot_isAuthenticated = () => this.store.selectSnapshot(FlatStates.AuthControlState.isAuthenticated$);

  //</editor-fold>
}
